/** @format */

import React, { useEffect, useMemo, useState } from 'react';
import adescomStyle from '../../assets/jss/adescom/adescomStyle';
import { useDispatch } from 'react-redux';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import { Select } from '@material-ui/core';
import I18n from '../../components/Translate/I18n';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import { makeStyles } from '@material-ui/core/styles';
import { dateConstants } from '../../modules/date/actions';
import { SimpleSelect } from '../Adescom/SimpleSelect';

const _ = require('underscore');

const useStyle = makeStyles(adescomStyle);

type DateSelectionProps = {
    type?: string;
};

export const DateSelection = (props: DateSelectionProps): React.ReactElement => {
    const classes = useStyle();
    const dispatch = useDispatch();
    const year = useMemo(() => new Date().getFullYear(), []);
    const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());
    const [selectedMonth, setSelectedMonth] = useState<number>(new Date().getMonth());
    const predefinedMonth = useMemo(() => {
        return new Date().getMonth();
    }, []);

    const yearRange = useMemo(() => {
        const years: Array<number> = [];
        for (let i = -15; i < 16; i++) {
            years.push(year + i);
        }
        return years;
    }, [year]);

    useEffect((): void => {
        dispatch({
            type: props.type ? props.type : dateConstants.DATE_EDIT,
            year: selectedYear,
            month: selectedMonth,
            predefinedMonth: predefinedMonth,
        });
    }, [dispatch, selectedYear, selectedMonth, predefinedMonth, props.type]);

    const changeYear = (event: any): void => {
        setSelectedYear(event.target.value);
    };

    const changeMonth = (event: any): void => {
        setSelectedMonth(event.target.value);
    };

    return (
        <GridContainer>
            <GridItem xs={6} xm={3} md={3}>
                <SimpleSelect
                    label={'general:common.year'}
                    required={true}
                    elements={yearRange.map((row: number) => {
                        return { name: row.toString(), value: row };
                    })}
                    callback={changeYear}
                    dispatchName={'test'}
                    selectedValue={selectedYear}
                />
            </GridItem>
            <GridItem xs={6} xm={3} md={3}>
                <SimpleSelect
                    label={'general:common.month'}
                    required={true}
                    elements={[
                        { name: 'general:month.january', value: 1 },
                        { name: 'general:month.february', value: 2 },
                        { name: 'general:month.march', value: 3 },
                        { name: 'general:month.april', value: 4 },
                        { name: 'general:month.may', value: 5 },
                        { name: 'general:month.june', value: 6 },
                        { name: 'general:month.july', value: 7 },
                        { name: 'general:month.august', value: 8 },
                        { name: 'general:month.september', value: 9 },
                        { name: 'general:month.october', value: 10 },
                        { name: 'general:month.november', value: 11 },
                        { name: 'general:month.december', value: 12 },
                    ]}
                    callback={changeMonth}
                    dispatchName={'test'}
                    selectedValue={selectedMonth}
                />
            </GridItem>
        </GridContainer>
    );
};
